import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header/Header';
import { ToastContainer } from '@/components/Toast/Toast';
import { initializePreferences } from '@/stores/preferencesStore';
import './theme.css';
import styles from './App.module.css';

export function App() {

  useEffect(() => {
    initializePreferences();
  }, []);

  // Determine which logo to use based on theme
  const footerLogo = 'logo-cinfo-white.svg';

  return (
    <div className={styles.app}>
      <Header />
      <main className={styles.main}>
        <div className={styles.container}>
          <Outlet />
        </div>
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <img 
            src={footerLogo} 
            alt="Cinfo" 
            className={styles.footerLogo}
          />
          <div className={styles.footerText}>
            <p className={styles.footerTitle}>Metadata Tags Test UI</p>
            <p className={styles.footerSubtitle}>made with ♥︎ for Astex</p>
          </div>
        </div>
        <p className={styles.footerCopyright}>
          © {new Date().getFullYear()} Cinfo. All rights reserved.
        </p>
      </footer>
      <ToastContainer />
    </div>
  );
}
